import React from 'react';
import { InjectedRouter } from 'react-router';
import { withRouterPropTyped } from 'app/context/Router';

type Props = {
  router: InjectedRouter;
  params: { uuid: string };
};

class IntegrationPageIndex extends React.Component<Props, {}> {
  componentDidMount() {
    this.props.router.replace(`/integrations/${this.props.params.uuid}/content`);
  }

  render() {
    return null;
  }
}

export { IntegrationPageIndex };
export default withRouterPropTyped(IntegrationPageIndex);
